import { PartnerPaymentInfo } from '@atlassian/developer-space';
import { useFeatureFlags } from '@atlassian/mpac-feature-flags';
import { useTwoStepAuthTimedOut } from '@atlassian/mpac-ui';
import { DOMUtils, PARTNER_NAV_ITEMS } from '@atlassian/mpac-utils';
import React from 'react';
import TwoStepSessionTimedOutModal from '../../common/components/TwoStepSessionTimedOutModal';
import { usePartnerUserPreferencesContext } from '../../common/PartnerUserPreferences/PartnerUserPreferences';
import PartnerApps from '../Apps/components/AppsList/PartnerApps/PartnerApps';
import PartnerAdmin from '../PartnerAdmin';
import PartnerAuditLogs from '../PartnerAuditLogs';
import PartnerContacts from '../PartnerContacts';
import PartnerProfile from '../PartnerProfile';
import PartnerReports from '../PartnerReports';
import PartnerSecurity from '../PartnerSecurity';
import Promotions from '../Promotions';
import ManagePartnersSideNavLayout from './ManagePartnersSideNavLayout';
import ManagePartnersTabLayout from './ManagePartnersTabLayout';
import NewCategoryAnnouncementModal from './NewCategoriesAndKeywords/AnnouncementModal';
import { getAuthorisedTabs } from './utils';
export const TabNames = {
  [PARTNER_NAV_ITEMS.APPS]: 'Apps',
  [PARTNER_NAV_ITEMS.DETAILS]: 'Details',
  [PARTNER_NAV_ITEMS.TEAM]: 'Team',
  [PARTNER_NAV_ITEMS.PAYMENT_INFO]: 'Payment',
  [PARTNER_NAV_ITEMS.PROMOTIONS]: 'Promotions',
  [PARTNER_NAV_ITEMS.SECURITY]: 'Security',
  [PARTNER_NAV_ITEMS.REPORTS]: 'Reports',
  [PARTNER_NAV_ITEMS.SALE_REPORTS]: 'Reports',
  [PARTNER_NAV_ITEMS.FEEDBACK_REPORTS]: 'Reports',
  [PARTNER_NAV_ITEMS.ADMIN]: 'Admin',
  [PARTNER_NAV_ITEMS.AUDIT_LOGS]: 'Audit logs'
};
// AMKT-34618 - Clean up task after 100% rollout of side navigation
const ManagePartners = props => {
  var _preferences$preferen, _preferences$preferen2;
  const {
    partnerDetails,
    partnerId,
    selectedTab,
    mpacBaseUrl,
    permissions
  } = props;
  const preferences = usePartnerUserPreferencesContext();
  const partnerDetailsData = partnerDetails.data;
  const TabComponents = {
    [PARTNER_NAV_ITEMS.DETAILS]: PartnerProfile,
    [PARTNER_NAV_ITEMS.TEAM]: PartnerContacts,
    [PARTNER_NAV_ITEMS.PROMOTIONS]: Promotions,
    [PARTNER_NAV_ITEMS.ADMIN]: PartnerAdmin,
    [PARTNER_NAV_ITEMS.PAYMENT_INFO]: PartnerPaymentInfo,
    [PARTNER_NAV_ITEMS.SECURITY]: PartnerSecurity,
    [PARTNER_NAV_ITEMS.APPS]: PartnerApps,
    [PARTNER_NAV_ITEMS.REPORTS]: PartnerReports,
    [PARTNER_NAV_ITEMS.AUDIT_LOGS]: PartnerAuditLogs
  };
  const {
    displayAuditTabInManagePartnerPage,
    enableNewCategoriesAndKeywordsMessage,
    partnersNavigationRefresh
  } = useFeatureFlags();
  const {
    isTwoStepAuthTimedOut,
    setTwoStepAuthTimedOut
  } = useTwoStepAuthTimedOut();
  const authorisedTabs = getAuthorisedTabs(permissions, displayAuditTabInManagePartnerPage);
  const TabComponent = TabComponents[selectedTab];
  const NavigationalComponent = partnersNavigationRefresh ? ManagePartnersSideNavLayout : ManagePartnersTabLayout;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(NavigationalComponent, {
    authorisedTabs: authorisedTabs,
    partnerDetailsData: partnerDetailsData,
    selectedTab: selectedTab,
    mpacBaseUrl: mpacBaseUrl,
    partnerId: partnerId,
    permissions: permissions
  }, /*#__PURE__*/React.createElement(TabComponent, {
    partnerId: partnerId,
    mpacBaseUrl: mpacBaseUrl,
    permissions: permissions,
    partnerUserPreferences: {
      isNewReportsView: !!(preferences !== null && preferences !== void 0 && (_preferences$preferen = preferences.preferences) !== null && _preferences$preferen !== void 0 && _preferences$preferen.isNewReportsView),
      isPatternedChart: (preferences === null || preferences === void 0 ? void 0 : (_preferences$preferen2 = preferences.preferences) === null || _preferences$preferen2 === void 0 ? void 0 : _preferences$preferen2.isPatternedChart) || false
    },
    partnerDetails: partnerDetails
  })), !DOMUtils.isSynthetic() && enableNewCategoriesAndKeywordsMessage && (permissions === null || permissions === void 0 ? void 0 : permissions.canManageAppDetails) && /*#__PURE__*/React.createElement(NewCategoryAnnouncementModal, null), isTwoStepAuthTimedOut && /*#__PURE__*/React.createElement(TwoStepSessionTimedOutModal, {
    setCancel: setTwoStepAuthTimedOut
  }));
};
export default ManagePartners;